<template>
    <div
        v-show="isDialogShow"
        id="dialog"
        ref="refDialog">
        <div class="wrap-box">
            <div
                ref="refWrap"
                :class="[dialogType, dialogType == 'rules' ? '' : 'flex_layout flex_flexDirection_column flex_xy_center']"
                class="wrap">
                <div 
                    v-if="dialogType == 'copy'"
                    class="copy">
                    <p class="tips flex_layout flex_xy_center">暂时无法更换绑定账号, 请复制至浏览器打开, 更换绑定账号</p>
                    <div 
                        v-clipboard:copy="currentUrl"
                        v-clipboard:success="copySuccess"
                        class="dialog-btn flex_layout flex_xy_center">{{ copyText }}</div>
                </div>
                <div
                    v-if="dialogType == 'account-list'"
                    class="account-list">
                    <p class="confirm-title title flex_layout flex_xy_center">{{ current_vip.award_title }}</p>
                    <p class="sub-title">请从以下手机号选择权益领取账号：</p>
                    <p 
                        v-if="!$attrs.phone_list.length" 
                        class="no-data-text">暂无可使用手机号</p>
                    <div class="account-wrap">
                        <div
                            v-for="(item) in $attrs.phone_list"
                            :key="item.account"
                            :class="{active: currentPhone == item.account}"
                            class="phone-item flex_layout flex_y_center flex_x_spacebetween"
                            @click="currentPhone = item.account">
                            手机号: {{ item.account }} <span class="phone-check"/>
                        </div>
                    </div>
                    <p class="times-tips flex_layout flex_xy_center">
                        本活动剩余增加领取手机号次数：<span class="red-text">{{ $attrs.times > 0 ? $attrs.times : 0 }}</span>次 <span 
                            :class="{disabled: $attrs.times <= 0}"
                            class="red-text add-text"
                            @click="addPhone">增加&gt;</span>
                    </p>
                    <div 
                        class="dialog-btn flex_layout flex_xy_center" 
                        @click="confirmChangePhone">确认领取</div>
                    <p class="btn-tips">{{ current_vip.btnBottomTips }}</p>
                </div>
                <div
                    v-if="dialogType == 'bind'"
                    class="bind">
                    <p class="title">{{ current_vip.assign_account ? '变更' : '绑定' }}领取账号</p>
                    <input
                        v-model="phone"
                        type="tel"
                        class="input phone"
                        placeholder="请输入手机号"
                        @focus="targetFocus"
                        @blur="blurHandler">
                    <div class="code-wrap flex_layout flex_x_spacebetween flex_y_center">
                        <input
                            v-model="code"
                            type="tel"
                            maxlength="6"
                            class="input sms-code"
                            placeholder="请输入验证码"
                            @focus="targetFocus"
                            @blur="blurHandler">
                        <div
                            :class="{ disabled: isSendCode }"
                            class="code-btn flex_layout flex_xy_center"
                            @click="getCode">{{ isSendCode ? `已发送(${countdown})` : '获取验证码' }}</div>
                    </div>
                    <div 
                        class="dialog-btn flex_layout flex_xy_center" 
                        @click="bindPhone">{{ current_vip.assign_account ? '确定变更' : '确定绑定' }}</div>
                </div>
                <div 
                    v-if="dialogType == 'qq'" 
                    key="qq" 
                    class="qq">
                    <p class="title">输入QQ账号</p>
                    <input 
                        v-model="qq" 
                        type="tel" 
                        class="input phone" 
                        placeholder="请输入QQ号" 
                        @focus="targetFocus" 
                        @blur="blurHandler">
                    <input 
                        v-model="qqConfirm" 
                        type="tel" 
                        class="input phone qq" 
                        placeholder="请再次输入QQ号" 
                        @focus="targetFocus" 
                        @blur="blurHandler">
                    <div 
                        class="dialog-btn flex_layout flex_xy_center" 
                        @click="bindQQ">{{ current_vip.assign_account ? '确定变更' : '确定绑定' }}</div>
                </div>
                <div 
                    v-if="dialogType == 'confirm'" 
                    key="confirm" 
                    class="confirm">
                    <p class="confirm-title title flex_layout flex_xy_center">{{ current_vip.award_title }}</p>
                    <p
                        class="assign-info flex_layout flex_xy_center" 
                        @click="changeAcount">
                        <span class="flex_layout flex_xy_center">
                            {{ current_vip.assign_account_prefix || '昵称: ' }}
                            <span
                                :class="{single: current_vip.isKuaikanGift}" 
                                class="acount">{{ current_vip.assign_account ? decodeURIComponent(current_vip.assign_account) : '暂无账号' }}</span>
                        </span>
                        <span
                            v-if="isShowChangeBtn"
                            :class="{disabled: current_vip.awardChangePhoneTimes > 0 || current_vip.allow_modify >= 1 }" 
                            class="change">变更&gt;</span>
                    </p>
                    <p 
                        v-if="current_vip.words_info.confirm_tips" 
                        class="tips" 
                        v-html="confirmTips"/>
                    <div 
                        class="dialog-btn flex_layout flex_xy_center" 
                        @click="assignVip">{{ returnBtnText() }}</div>
                    <p class="btn-tips">{{ current_vip.btnBottomTips }}</p>
                </div>
                <div 
                    v-if="dialogType == 'rules'" 
                    key="rules" 
                    class="rules">
                    <p class="title">{{ $attrs.title }}</p>
                    <div 
                        class="rules-text" 
                        v-html="rules"/>
                </div>
                <div 
                    v-if="dialogType == 'auto-close'" 
                    key="auto-close" 
                    class="auto-close">
                    <p class="tips">即将跳转第三方授权页面<br>如果无法正常跳转,此页面将在5秒后自动关闭<br>您可以点击下面按钮取消自动关闭</p>
                    <div 
                        class="dialog-btn flex_layout flex_xy_center" 
                        @click="cancelAutoClose">取消自动关闭</div>
                </div>
                <div 
                    v-if="dialogType == 'refund'" 
                    key="refund" 
                    class="refund">
                    <p class="title">申请退款</p>
                    <p class="content new">我们将按实际支付金额全额退款，预计30个工作日内完成，退款后已领取权益将在活动结束后统一收回</p>
                    <p class="tips new">*申请退款后将不能再领取权益，若选择领取其他替代QQ超级会员或领满任意4个会员，将默认不退款</p>
                    <div 
                        class="dialog-btn flex_layout flex_xy_center" 
                        @click="refundCallback()">确认退款</div>
                </div>
                <div 
                    v-if="dialogType == 'cancel'" 
                    key="cancel" 
                    class="cancel">
                    <p class="title">撤销退款</p>
                    <p class="content new">撤销退款后，我们将取消本次退款申请，您可以继续领取并且不再追回您已领取的权益</p>
                    <p class="tips new">*若您正处于“退款中”和“退款完成”状态，则不支持撤销退款</p>
                    <div 
                        class="dialog-btn flex_layout flex_xy_center" 
                        @click="cancelCallback()">确认撤销</div>
                </div>
                <div 
                    v-if="dialogType == 'code'" 
                    key="code" 
                    class="code">
                    <p class="confirm-title title flex_layout flex_xy_center">{{ returnCodeTitle() }}</p>
                    <p class="content vip-code">
                        {{ $attrs.code_content }}
                        <em 
                            class="copy-code" 
                            @click="copyCode"/>
                    </p>
                    <div
                        v-if="returnCodeLink()"
                        class="dialog-btn flex_layout flex_xy_center" 
                        @click="clickCodeLink()">复制去兑换</div>
                </div>

            </div>
            <div 
                v-if="isTipsShow" 
                class="wrap flex_layout flex_flexDirection_column flex_xy_center">
                <div class="tips confirm">
                    <p class="title">{{ current_vip.award_title }}</p>
                    <p class="content">{{ returnTips() }}</p>
                    <div 
                        class="dialog-btn flex_layout flex_xy_center" 
                        @click="closeTips">我知道了</div>
                </div>
            </div>
            <div 
                v-show="isBtnShow" 
                ref="refClose" 
                class="close" 
                @click="close"/>
        </div>
    </div>
</template>

<script>
import xss from "@kkmh/xss";
//let Console=console;
export default {
    name: "DialogComp",
    props: {
        current_vip: {
            type: Object,
            default: () => {
                return {};
            }
        },
        change_type: {
            type: Number,
            default: 0
        },
        reset_is_send_code:{
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            currentUrl: location.href + "&useragent=",
            currentPhone: "",
            isSendCode: false, // 验证码倒计时标记
            countdown: 60, // 验证码倒计时
            isBtnShow: true,
            isTipsShow: false,
            isDialogShow: false,
            dialogType: "",
            timer: "",
            phone: "",
            code: "",
            qq: "",
            qqConfirm: "",
            clientHeight: document.documentElement.clientHeight,
            returnUrl: location.href,
            copyText: "复制链接",
            codeTitle: "",
            codeLink: "",
            ua: window.__gvalkkmh ? window.__gvalkkmh.ua : {},
        };
    },
    computed: {
        confirmTips() {
            return xss(this.current_vip.words_info.confirm_tips);
        },
        rules() {
            return xss(this.$attrs.rules);
        },
        isShowChangeBtn() {
            // 快看内部奖品不支持更换账号 端外环境且售卖商品不支持更换账号 activity_type=1 是售卖与外层相反
            console.error(this.ua.kkmh, this.ua);
            return !(this.current_vip.isKuaikanGift||(!this.ua.kkmh&&this.current_vip.activity_type==1));
        }
    },
    watch: {
        isSendCode(val) {
            val && (this.setCountdown());
        },
        isTipsShow(val) {
            this.$refs.refWrap.style.display = val ? "none" : (this.dialogType == "rules" ? "block" : (this.dialogType ? "flex" : "none"));
        },
        // 是否重置倒计时(按钮可以点击)
        reset_is_send_code(val){
            if(val === true){
                this.isSendCode=false;
                this.countdown = 60;
                clearInterval(this.timer); 
                this.timer = null;
                this.$emit("setResetIsSendCode");
            }
        }
    },
    mounted() {
        // 处理部分安卓 掉起软键盘输入后 元素定位位置变动问题
        window.onresize = () => {
            if (this.clientHeight > document.documentElement.clientHeight) {
                this.isBtnShow = false;
            } else {
                this.isBtnShow = true;
            }
        };
    },
    methods: {
        returnCodeLink() {
            if (this.current_vip.codeLink) {
                this.codeLink = this.current_vip.codeLink;
            }
            return this.codeLink;
        },
        returnCodeTitle() {
            if (this.current_vip.award_title) {
                this.codeTitle = this.current_vip.award_title;
            }
            return this.codeTitle;
        },
        addPhone() {
            this.$emit("add_phone_callback");
        },
        returnBtnText() {
            // if (this.$attrs.current_activity.activity_name == 'link_vip_module_charge' && this.current_vip.partner_id == 'QQ_SVIP') return '确认退款'
            return "确认领取";
        },
        targetFocus(e) {
            // 解决ios 11.3 下 input 触发不灵敏的问题(非第一次点击 键盘不能立即掉起 需要多次点击或者长按)
            e.target.focus();
        },
        blurHandler() {
            let result;
            if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
                result = "ios";
            } else if (/(Android)/i.test(navigator.userAgent)) { //判断Android
                result = "android";
            }

            if (result == "ios") {
                setTimeout(function () {
                    var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
                    window.scrollTo(0, Math.max(scrollHeight - 1, 0));
                }, 100);
            }
        },
        show(type) {
            this.dialogType = type;
            this.isDialogShow = true;
            this.$nextTick(() => {
                this.currentPhone = this.current_vip.assign_account;
                this.$refs.refWrap.style.display = this.dialogType == "rules" ? "block" : "flex";
                // 兼容 安卓低版本浏览器 不支持 scrollTo
                if (typeof this.$refs.refWrap.scrollTo === "function") {
                    this.$refs.refWrap.scrollTo(0, 0);
                }
                this.$refs.refDialog.ontouchmove = function() {
                    return type == "rules" || type == "record" || type == "account-list";
                };
            });
        },
        close() {
            this.$emit("reset_callback");
            this.dialogType = "";
            this.isTipsShow = false;
            this.isDialogShow = false;
            this.isSendCode = false;
            this.qq = "";
            this.qqConfirm = "";
            this.phone = "";
            this.code = "";
            this.countdown = 60;
            window.clearInterval(this.timer);
        },
        getCode() {
            if (this.isSendCode) return;
            // 海外手机号校验
            if (this.phone.indexOf("+") >= 0 || this.phone.indexOf("-") >= 0) return this.$emit("toast_callback", "应用暂不支持至海外手机号");
            // 国内手机号校验
            if (!/^[1][0-9][0-9]{9}$/.test(this.phone)) return this.$emit("toast_callback", "请输入有效的手机号码");
            this.isSendCode = true;
            this.$emit("get_code_callback", {phone: this.phone, smscode_type: 12});
        },
        showTips() {
            this.isDialogShow = true;
            this.isTipsShow = true;
        },
        closeTips() {
            this.isTipsShow = false;
            this.isDialogShow = this.dialogType;
        },
        bindPhone() {
            this.$emit("bind_phone_callback", {phone: this.phone, code: this.code});
        },
        bindQQ() {
            this.$emit("bind_qq_callback", {qq: this.qq, qqConfirm: this.qqConfirm});
        },
        changeAcount() {
            this.$emit("change_acount_callback");
            // if(this.current_vip.awardChangePhoneTimes > 0 || this.current_vip.allow_modify >= 1){
            //     this.$emit("toast_callback", "不可变更");
            //     return ;
            // } else {
            //     this.$emit("change_acount_callback");
            // }
        },
        setCountdown() { 
            this.timer && window.clearInterval(this.timer);
            this.timer = setInterval(() => {
                if (!this.isSendCode) {
                    window.clearInterval(this.timer);
                    return;
                }
                this.countdown--;
                if (this.countdown <= 0) {
                    this.timer && window.clearInterval(this.timer);
                    this.countdown = 60;
                    this.isSendCode = false;
                }
            }, 1000);
        },
        assignVip() {
            this.$emit("assign_callback", this.current_vip);
        },
        returnTips() {
            let ua = window.__gvalkkmh.ua;
            return `请使用当前购买时${ua.wechatmini ? "的微信账号" : (ua.qqmini ? "的QQ账号" : (ua.baidumini ? "绑定的手机账号" : ""))}, 登录最新快看漫画app进行领取操作~`;
        },
        cancelAutoClose() {
            this.$emit("cancel_auto_close_callback");
        },
        refundCallback() {
            this.$emit("refund_callback");
        },
        cancelCallback() {
            this.$emit("cancel_refund_callback");
        },
        confirmChangePhone() {
            this.$emit("confirm_change_phone", this.currentPhone);
        },
        copySuccess() {
            this.copyText = "复制成功!请使用浏览器打开";
            this.showCopyToast();
        },
        showCopyToast() {
            this.$emit("toast_callback", "复制成功");
        },
        copyCode() {
            this.$copyText(this.$attrs.code_content);
            this.showCopyToast();
        },
        clickCodeLink() {
            this.copyCode();
            this.close();
            this.$emit("code_link_callback", this.codeLink);
        }
        
    
    }
};
</script>

<style lang="scss" scoped>
@import '@/assets/sass/vws.scss';

@-webkit-keyframes scale-up-center {
  0% {
    -webkit-transform:scale(0.5);
            transform:scale(0.5);
  }
  100% {
    -webkit-transform:scale(1);
            transform:scale(1);
  }
}
@keyframes scale-up-center {
  0% {
    -webkit-transform:scale(0.5);
            transform:scale(0.5);
  }
  100% {
    -webkit-transform:scale(1);
            transform:scale(1);
  }
}

#dialog {
  z-index: 11;
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, .85);
}
.wrap-box {
  position: absolute;
  left: 50%;
  top: 50%;
  transform:translate(-50%, -50%)
}
.wrap {
  padding-top: vws(40px);
  padding-bottom: vws(29px);
  width: vws(560px);
  background: #FFFFFF;
  border-radius: vws(24px);
  text-align: center;
  color: #4A2525;
  -webkit-animation: scale-up-center 0.4s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
          animation: scale-up-center 0.4s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;

  &.rules {
    height: vws(657px);
    padding: vws(42px) vws(54px);
    overflow-x: hidden;
    overflow-y: scroll;
    word-break: break-all;
  }
  &.record {
    width: vws(600px);
    overflow-y: scroll;
  }
}
.title {
  font-size: vws(40px);
  line-height: 1.15;
  font-weight: 600;
  .rules & {
    margin-bottom: vws(25px);
    font-size: vws(34px);
    line-height: 1.15;
  }
}
.confirm-title {
  position: absolute;
  top: vws(-30px);
  left: 50%;
  width: vws(480px);
  height: vws(70px);
  background: #FFF4BA;
  border: 1px solid #FFA23E;
  border-radius: vws(10px);
  font-size: vws(36px);
  line-height: 1.15;
  font-weight: 400;
  transform: translateX(-50%);
}
.sub-title {
    margin-top: vws(25px);
    margin-bottom: vws(22px);
    font-size: vws(24px);
    font-weight: 400;
    line-height: 1.15;
    color: #4A2525;
}

.rules-box {
  width: 100%;
  height: 100%;
}
.rules-title {
  margin-top: vws(25px);
  margin-bottom: vws(15px);
  color: #422222;
  font-size: vws(26px);
  font-weight: 600;
  text-align: left;
}
.rules-img {
  margin: vws(10px) 0;
}
.rules-text {
  color: #422222;
  font-size: vws(24px);
  text-align: left;
}
.close {
  position: relative;
  margin: 0 auto;
  margin-top: vws(50px);
  // position: absolute;
  // left: 50%;
  // bottom: vws(218px);
  // margin-left: vws(-29px);
  width: vws(58px);
  height: vws(58px);
  border: 1px solid #fff;
  border-radius: 50%;

  &::after {
    content: '';
    position: absolute;
    left: 50%;
    top: 50%;
    display: block;
    width: vws(20px);
    height: 1px;
    background: #fff;
    transform: translate(-50%, -50%) rotate(-45deg);
  }
  &::before {
    content: '';
    position: absolute;
    left: 50%;
    top: 50%;
    display: block;
    width: vws(20px);
    height: 1px;
    background: #fff;
    transform: translate(-50%, -50%) rotate(45deg);
  }
}
.input {
  height: vws(84px);
  background: #FFFFFF;
  border: 1px solid #4A2525;
  border-radius: vws(20px);
  outline: #4A2525;
  text-indent: vws(30px);
  font-size: vws(30px);
  vertical-align: middle;
}
.input::placeholder {
  color: rgba(74, 37, 37, .4);
  font-size: vws(30px);
  font-weight: 500;
  text-indent: vws(30px);
}
.input::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  color: rgba(74, 37, 37, .4);
  font-size: vws(30px);
  font-weight: 500;
  text-indent: vws(30px);
}
.input::-moz-placeholder { /* Firefox 19+ */
  color: rgba(74, 37, 37, .4);
  font-size: vws(30px);
  font-weight: 500;
  text-indent: vws(30px);
}
.input::-ms-input-placeholder { /* IE 10+ */
  color: rgba(74, 37, 37, .4);
  font-size: vws(30px);
  font-weight: 500;
  text-indent: vws(30px);
}
.phone {
  margin-top: vws(42px);
  width: vws(474px);
  &.qq {
    margin-top: vws(22px);
  }
}
.sms-code {
  width: vws(260px);
}
.code-wrap {
  margin-top: vws(22px);
  margin-bottom: vws(19px);
}
.code-btn {
  width: vws(200px);
  height: vws(84px);
  background: #FCE04E;
  border-radius: vws(20px);
  font-size: vws(30px);
  font-weight: 400;
  color: #4A2525;
  &.disabled {
    background: #eee;
    color: #aaa;
  }
}
.tips {
  padding: 0 vws(30px);
  font-size: vws(22px);
  font-weight: 400;
  color: #4A2525;
  text-align: center;
}
.confirm {
  color: #4A2525;
  .assign-info {
    margin: 0 auto;
    margin-top: vws(49px);
    margin-bottom: vws(24px);
    // max-width: vws(480px);
    font-size: vws(30px);
    line-height: 1.15;
    font-weight: 400;
  }
  .acount {
    display: inline-block;
    max-width: vws(240px);
    color: #FB4E4E;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    text-align: left;
    vertical-align: top;
    &.single {
        max-width: vws(360px)
    }
  }
  .change {
    margin-left: vws(30px);
    color: #FB4E4E;
    text-decoration: underline;
    &.disabled {
      color: #ccc;
    }
  }
}
.content {
  margin-top: vws(24px);
  padding: 0 vws(30px);
  font-size: vws(26px);
}
.dialog-btn {
  margin: 0 auto;
  margin-top: vws(40px);
  width: vws(474px);
  height: vws(84px);
  background: #FCE04E;
  border-radius: vws(42px);
  font-size: vws(30px);
  font-weight: 400;
}
.account-list .dialog-btn{
    margin-top: 0;
}
.list {
  margin-top: vws(50px);
  padding-bottom: vws(29px);
  font-size: vws(24px);
}
.record-box {
  max-height: vws(450px + 200px);
}
.list-item {
  margin-bottom: vws(10px);
  padding: vws(16px) vws(24px);
  width: vws(502px);
  background: #FDF7E7;
  border-radius: vws(10px);
  text-align: left;
}
.item-title {
  font-size: vws(28px);
  color: #4A2525
}
.item-detail {
  font-size: vws(24px);
  color: rgba(74, 37, 37, .4);
}
.new {
  text-align: left;
  text-indent: vws(54px);
}
.account-wrap {
  max-height: vws(348px);
  overflow: scroll;
}
.phone-item {
    margin-bottom: vws(15px);
    padding-left: vws(52px);
    padding-right: vws(28px);
    width: vws(512px - 52px - 28px);
    height: vws(50px);
    border-radius: vws(25px);
    font-size: vws(28px);
    line-height: 1.15;
    color: #4A2525;
    &.active {
        background: #FFF0D4;
    }
}
.phone-check {
    .active & {
        display: inline-block;
    }
    display: none;
    width: vws(25px);
    height: vws(17px);
    background: url(../img/phone-check.png) no-repeat 0 0/100% 100%;
}
.red-text {
    color: #FE4C48;
}
.times-tips {
    margin-top: vws(22px);
    margin-bottom: vws(21px);
    font-size: vws(20px);
    line-height: 1.15;
    color: #4A2525;
}
.add-text {
    margin-left: vws(18px);
    font-size: vws(24px);
    line-height: 1.15;
    text-decoration: underline;
    color: #FE4C48;
    &.disabled {
        color: #ccc;
    }
}
.btn-tips {
    margin-top: vws(18px);
    font-size: vws(20px);
    line-height: 1.15;
    color: rgba(74, 37, 37, .6);
    text-align: center;
}
.no-data-text {
    font-size: vws(20px);
    line-height: 1.15;
    color: rgba(74, 37, 37, .6);
    text-align: center;
}

.copy-code {
  display: inline-block;
  width: vws(20px);
  height: vws(20px);
  background: url(../assign/img/copy.png) no-repeat center center/100% 100%;
}
.vip-code {
  font-size: vws(24px);
}
</style>


// WEBPACK FOOTER //
// src/pages/native/pay/vip/link_vip_multiple/comp/dialog.vue